export enum AgropilotRole {
  SUPPLY_MANAGER = 'SUPPLY_MANAGER',
  PC_RADIO = 'PC_RADIO',
  TECHNICIAN = 'TECHNICIAN',
  SITE_MANAGER = 'SITE_MANAGER',
  RECEPTION_CENTER = 'RECEPTION_CENTER',
  FACTORY = 'FACTORY',
}
